// Notification Hook
// uses a promise to wait for user input from the notification
import { useState } from "react";
import { Button, Container, Row, Col, Form } from 'react-bootstrap';

function useNotification() {
  const [ resolver, setResolver ] = useState({ resolver: null });
  const [openModal, setOpenModal] = useState(false);
  const [notificationData, setNotificationData] = useState({tech:true, client:true});

  const createPromise = () => {
    let resolver;
        return [ new Promise(( resolve, reject ) => {

            resolver = resolve
        }), resolver]
  };

  const getConfirmation = async (custEmail) => {
    if(custEmail === ""){
        setNotificationData({
            ...notificationData,
            client: false
        });
    }else{
        setNotificationData({
            ...notificationData,
            client: true
        });
    }
    setOpenModal(true);
    const [ promise, resolve ] = await createPromise()
    setResolver({ resolve })
    return promise;
  };

  const sendNotification = ()=>{
    setOpenModal(false);
    resolver.resolve(notificationData);
  };

  const NotificationModal = ({custEmail}) => {
    return (
        <>
            {openModal && 
                <div  style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 999, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <dialog
                        open
                    >
                        <Container>
                            <Row className="fs-4">
                                Choose Notification Options:
                            </Row>
                            <Row className="mt-2">
                                <Form>
                                    <Form.Check
                                        type="checkbox"
                                        label="Technician Notification" 
                                        id="tech_notification"
                                        checked={notificationData.tech}
                                        onChange={()=>{
                                            setNotificationData({
                                                ...notificationData,
                                                tech: !notificationData.tech
                                            });
                                        }}
                                    />
                                    <Form.Check
                                        type="checkbox"
                                        label="Client Dispatch Email"
                                        id="client_dispatch_email"
                                        checked={custEmail === "" ? false : notificationData.client}
                                        onChange={()=>{
                                            setNotificationData({
                                                ...notificationData,
                                                client: !notificationData.client
                                            });
                                        }}
                                        disabled={custEmail === "" ? true : false}
                                    />
                                </Form>
                            </Row>
                            <Row className="mt-4">
                                <Col style={{textAlign:'right'}}>
                                    <Button
                                        onClick={()=>{sendNotification()}}
                                        className="btn-dark"
                                        style={{backgroundColor:"#2596be", margin:5}}
                                    >
                                        {notificationData.tech || notificationData.client ? "Send" : "No Notifications"}
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </dialog>
                </div>
            }
        </>
    )
  };

    return [getConfirmation, NotificationModal];
}

export default useNotification;